export default __webpack_public_path__ + "assets/icons/home_chevron.f778515c.svg";